import React from "react";
import { connect } from "react-redux";
import Select from 'react-select';
import { Field, reduxForm, change } from "redux-form";

import "./NewExternalUnit.css"

import history from "../../../../history";
import { getExternalUnit, newExternalUnit, editExternalUnit } from "../../../../actions/externalUnitActions";
import { getAllUsers } from "../../../../actions/userActions";

import Form from "../../../CustomViews/Form";

const ExternalUnitForm = reduxForm({ form: "externalUnitForm" })(Form);

class NewExternalUnit extends React.Component {
    constructor(props) {
        super(props);

        this.rerenderFunction = null;

        this.state = {
            coordinatorID: { label: "", value: null }
        };
    }

    componentDidMount() {
        this.loaded = false;
        if (this.props.mode === "edit") this.props.getExternalUnit(this.props.match.params.externalOuID);
        this.props.getAllUsers();
    }

    componentDidUpdate() {
        if (this.rerenderFunction) this.rerenderFunction();
        if (this.props.currentUser.userID && this.props.currentUser.admin === 0) history.push("/");
        else if (this.props.mode === "edit" && this.props.externalUnit.externalOuID && !this.loaded) {
            this.props.change("externalUnitForm", "name", this.props.externalUnit.name);
            this.loaded = true;
            this.setState({ coordinatorID: {
                label: `${this.props.externalUnit.coordinatorLname} ${this.props.externalUnit.coordinatorFname}`,
                value: this.props.externalUnit.coordinatorID
            } });
        }
    }

    onSubmit = (formValues, onFormError) => {
        if (formValues.addCoordinator === null || formValues.addCoordinator === undefined) formValues.addCoordinator = false;
        if (this.state.coordinatorID.value) formValues.coordinatorID = this.state.coordinatorID.value;
        if (this.props.mode === "edit") this.props.editExternalUnit(this.props.match.params.externalOuID, formValues, onFormError, () => history.push(`/structure/external/details/${this.props.match.params.externalOuID}`));
        else this.props.newExternalUnit(formValues, onFormError);
    };

    renderFieldError = (name, formErrors, renderError) => {
        const error = formErrors.filter(err => err.field === name)[0];
        return renderError(error);
    };

    renderFields = (_, __, ___, renderInput, formErrors, renderError) => {
        return (
            <React.Fragment>
                <div className="ui segments">
                    <div className="ui segment">
                        <div className="ui header">
                            <i className="building icon"></i>
                            {this.props.mode === "edit" ? "Edycja firmy zewnętrznej" : "Nowa firma zewnętrzna"}
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="ui grid">
                            <div className="one column row">
                                <div className="column">
                                    <div className="content">
                                        <b>{this.props.mode === "edit" ? "Nowa nazwa" : "Nazwa"}</b><br />
                                        <Field type="text" name="name" component={renderInput} placeholder="Wpisz nazwę..." />
                                        {this.renderFieldError("name", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                            <div className="one overflow column row">
                                <div className="overflow column">
                                    <div className="content">
                                        <b>{this.props.mode === "edit" ? "Nowy koordynator" : "Koordynator"}</b><br />
                                        <Select
                                            value={this.state.coordinatorID}
                                            onChange={value => this.setState({ coordinatorID: value })}
                                            options={this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u.userID } })}
                                            placeholder="Koordynator"
                                            noOptionsMessage={() => "Nie znaleziono użytkownika"}
                                            maxMenuHeight="400px"
                                        />
                                        {this.renderFieldError("coordinatorID", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                            <div className="one column row">
                                <div className="column">
                                    <div className="content">
                                        <b>Dodaj koordynatora do fimry</b><br />
                                        <Field type="checkbox" name="addCoordinator" component={renderInput} />
                                        {this.renderFieldError("addCoordinator", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="ui button primary">Zatwierdź</button>
            </React.Fragment>
        );
    };

    getRerenderFunction = (rerenderFunction) => this.rerenderFunction = rerenderFunction;

    render() {
        return (
            <React.Fragment>
                <div className="new-external-unit-component ui container">
                    <div className="ui container">
                        <ExternalUnitForm getRerenderFunction={this.getRerenderFunction} onSubmit={this.onSubmit} renderFields={this.renderFields} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    usersList: state.user.list,
    externalUnit: state.externalUnit.current
});

export default connect(mapStateToProps, { getExternalUnit, getAllUsers, newExternalUnit, editExternalUnit, change })(NewExternalUnit);